import {createSSRApp} from "vue";
import {renderToString} from "@vue/server-renderer";
import ChatMessageLinks from "@/modules/chat/components/message/ChatMessageLinks.vue";

export async function formLinks(links) {
    const component = createSSRApp(ChatMessageLinks, {
        links
    });
    let html = '';
    try {
        html = await renderToString(component)
    } catch (error) {
        html = '';
    }
    return html;
}